// ═══════════════════════════════════════════════════════════════
// ChroniclesRibbon — Journal éditorial ITRIIA en homepage
// Affichage discret premium, ciblage par visible_to côté API.
// Gracieusement silencieux si pas de contenu / backend absent.
// ═══════════════════════════════════════════════════════════════

import React, { useEffect, useState } from 'react';
import './ChroniclesRibbon.css';

const MONTHS_FR = [
  'janv.', 'févr.', 'mars', 'avril', 'mai', 'juin',
  'juill.', 'août', 'sept.', 'oct.', 'nov.', 'déc.',
];

function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d)) return '';
  return `${d.getDate()} ${MONTHS_FR[d.getMonth()]}`;
}

export default function ChroniclesRibbon({ limit = 4, placeholderIfEmpty = false }) {
  const [entries, setEntries] = useState(null); // null = en cours, [] = vide confirmé
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    let alive = true;
    const token = localStorage.getItem('oracle_token');
    if (!token) { setErrored(true); return; }

    fetch(`/api/chronicles?limit=${limit}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => {
        if (!r.ok) throw new Error(`status ${r.status}`);
        return r.json();
      })
      .then(list => { if (alive) setEntries(Array.isArray(list) ? list : []); })
      .catch(() => { if (alive) setErrored(true); });

    return () => { alive = false; };
  }, [limit]);

  // ─── Gestion gracieuse : pas d'affichage si backend absent / aucune entrée ───
  if (errored) return null;

  // En cours de chargement — skeleton placeholder très discret (optionnel)
  if (entries === null) {
    if (!placeholderIfEmpty) return null;
    return (
      <aside className="chr-ribbon chr-ribbon--loading" aria-busy="true">
        <div className="chr-ribbon__header">
          <span className="chr-ribbon__eyebrow">Chroniques</span>
          <span className="chr-ribbon__title">Vie d'<em>ITRIIA</em></span>
        </div>
        <div className="chr-ribbon__entries">
          {[0, 1, 2].map(i => (
            <article key={i} className="chr-ribbon__entry">
              <span className="chr-ribbon__date">—</span>
              <div className="chr-ribbon__body">
                <div className="chr-ribbon__entry-title">&nbsp;</div>
                <div className="chr-ribbon__entry-teaser">&nbsp;</div>
              </div>
            </article>
          ))}
        </div>
      </aside>
    );
  }

  if (entries.length === 0) return null;

  return (
    <aside className="chr-ribbon" aria-label="Chroniques ITRIIA">
      <div className="chr-ribbon__header">
        <span className="chr-ribbon__eyebrow">Chroniques</span>
        <span className="chr-ribbon__title">Vie d'<em>ITRIIA</em></span>
      </div>

      <div className="chr-ribbon__entries">
        {entries.map(entry => (
          <article key={entry.id} className="chr-ribbon__entry">
            <span className="chr-ribbon__date">{formatDate(entry.publish_date)}</span>
            <div className="chr-ribbon__body">
              <div className="chr-ribbon__entry-title">{entry.title}</div>
              <div className="chr-ribbon__entry-teaser">{entry.teaser}</div>
            </div>
          </article>
        ))}
      </div>

      <div className="chr-ribbon__glyph">§</div>
    </aside>
  );
}
